import React from 'react';
import './CustomModal.css';

const CustomModal = ({ onClose, onSelectEntree, onSelectSide }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h2 className="modal-title">
            A La Carte Selection
          </h2>
        </div>
        <div className="modal-content">
          <p className="modal-description">
            Would you like to order an entree or a side?
          </p>
          
          <div className="button-container">
            <button 
              className="primary-button"
              onClick={onSelectEntree}
            >
              Entrees
            </button>
            
            <button 
              className="primary-button"
              onClick={onSelectSide}
            >
              Sides
            </button>
            
            <button 
              className="cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
